/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps, Modal, ModalBody, ModalFooter, ModalHeader, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrderTemplateLineViewProps } from './components';
import { IOrderTemplateViewProps } from './krannich-c-order-template';
import { incExcPriceFormat, taxPercentage } from '../../utils/helper';

const OrderTemplateLinesView: React.FC<IOrderTemplateViewProps> = (props: IOrderTemplateViewProps) => {
    const {
        OrderTemplateLines,
        status,
        statusMessage,
        heading,
        ProductsTable,
        ProductsTableHeading,
        orderLines,
        ProductsTableRow,
        productsStatusMessage,
        OrderTemplateActions,
        orderActions,
        pagination,
        // itemAddedToCartDialog,
        bulkOrderLineActions,
        isDetailsDisplayed,
        detailedProductView,
        toggleDetailsDisplayed,
        isSelectedProdPopUpShow,
        addedLinesToPassArr,
        addedLinesToPassArrSuccessfull,
        isAllselectedItemsAddedSuccessfully,
        _handlerToClearSelectedPopUp,
        resources: {
            cancelBtnLabel,
            productNumberText,
            productText,
            productUnitPriceText,
            productUOMText,
            productQuantityText,
            renameOrderTemplateButtonText,
            productLineCatalogName,
            addOrderTemplateItemToBagButtonText,
            addOneItemToCartMessage,
            addLineItemNumberPrefix,
            addLineProductUnitPricePrefix,
            addLineProductUnitOfMeasurePrefix,
            totalPriceLabel,
            deleteProductLabel,
            deleteProductFromOrderTemplate,
            deleteButtonText,
            backText,
            productsText,
            addedToCartText,
            productSingleText,
            itemsExceedQuantityLimitsAddedToCartText,
            viewCartAndCheckoutText,
            closeWindowButtonText,
            productDetailsText
        },
        context
    } = props;

    const { enabledIncExPrices } = props.context.app.config;
    const { addedToCartFailureCustomMessage, zeroPriceProductText } = props.resources;
    const toggleDetails = React.useCallback(() => {
        toggleDetailsDisplayed && toggleDetailsDisplayed(undefined);
    }, [toggleDetailsDisplayed]);
    //VSI Customization to set toogle Values
    const [toogleShow, setToogleShow] = React.useState<boolean>(false);
    const [deletedToogleShow, setDeletedToogleShow] = React.useState<boolean>(false);
    const [indexValue, setIndexValue] = React.useState<number>();
    //VSI CUSTOMIZATION TO CREATE OUR OWN CUSTOMN ADD TO CART BUTTON
    const addToBagButton = (index: number) => {
        const clickValue = () => {
            setToogleShow(!toogleShow);
            setIndexValue(index);
        };
        return <button className='add-bag-template' tabIndex={0} onClick={clickValue} aria-label='Add product to bag' />;
    };
    const addToBagButtonDisabled = () => {
        return <div className='add-bag-template-disabled'>{addOrderTemplateItemToBagButtonText}</div>;
    };
    //VSI CUSTOMIZATION TO CREATE OUR OWN CUSTOMN REMOVE BUTTON
    const removeButtonCustom = (index: number) => {
        const clickValue = () => {
            setDeletedToogleShow(!deletedToogleShow);
            setIndexValue(index);
        };
        return <button className='delete-template-product' tabIndex={0} onClick={clickValue} aria-label='Delete product' />;
    };

    const _renderItem = (
        product: IOrderTemplateLineViewProps,
        quantityLabel: string,
        ProductsTableRow?: INodeProps,
        toogleShow?: boolean,
        setToogleShow?: React.Dispatch<React.SetStateAction<boolean>>,
        deletedToogleShow?: boolean,
        setDeletedToogleShow?: React.Dispatch<React.SetStateAction<boolean>>,
        productsStatusMessage?: React.ReactNode,
        index?: number
    ): JSX.Element | null => {
        //VSI CUSTOMIZATION FOR PRODUCT MODAL AND DELETE MODAL
        const customerTaxPercentage = taxPercentage(props.data.customerInformation?.result!);
        const ShowModal = () => {
            return (
                <Modal
                    wrapClassName='ms-order-template-add-to-cart-custom'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setToogleShow && setToogleShow(false);
                    }}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setToogleShow && setToogleShow(false);
                            }}
                        >
                            {addOneItemToCartMessage}
                        </ModalHeader>
                        <ModalBody>
                            <div className='order-template-modal-contianer'>
                                <div className='image-contianer'>{productImage}</div>
                                <div className='information-container'>
                                    <div className='detail-contianer'>
                                        <div className='_info'>{productInfo}</div>
                                        <div className='_number'>
                                            <span>{addLineItemNumberPrefix}&nbsp;</span>
                                            {productNumber}
                                        </div>
                                        <div className='_price'>
                                            <span>{addLineProductUnitPricePrefix}</span>
                                            {productPrice}
                                        </div>
                                        <div className='_uom'>
                                            <span>{addLineProductUnitOfMeasurePrefix} </span> {productUnitOfMeasure}
                                        </div>
                                    </div>
                                    <div className='quantity-container'>
                                        <div className='_quantity'>
                                            <span>{productQuantityText} </span>
                                            {productQuantityView}
                                        </div>
                                    </div>
                                </div>
                                {productsStatusMessage ? <span className='status-message'>{productsStatusMessage}</span> : null}
                            </div>
                            <div className='footer-container'>
                                {product.totalPrice === 0 ? (
                                    <></>
                                ) : (
                                    // <div className='total-price-container'>
                                    //     <span>Total A$ {totalBeforeTax}</span>
                                    // </div>
                                    <div className='total-price-container'>
                                        <span>
                                            {totalPriceLabel}{' '}
                                            {incExcPriceFormat(product.totalPrice!, context, enabledIncExPrices, customerTaxPercentage)}
                                        </span>
                                    </div>
                                )}
                                <div className='actions-container'>
                                    {product.isRequestPrice || product.isDiscontinued ? (
                                        <button className='_action-btn' disabled={true}>
                                            {addOrderTemplateItemToBagButtonText}
                                        </button>
                                    ) : (
                                        <span
                                            className='_action-btn'
                                            onClick={() => {
                                                setTimeout(() => {
                                                    setToogleShow && setToogleShow(false);
                                                }, 5000);
                                            }}
                                        >
                                            {addOrderTemplateItemToBagButtonText}
                                            {product.addToBagButton}
                                        </span>
                                    )}

                                    <button
                                        className='msc-delete-orderTemplateList-btn btn  cancel-btn '
                                        onClick={() => {
                                            setToogleShow && setToogleShow(false);
                                        }}
                                    >
                                        {cancelBtnLabel}
                                    </button>
                                </div>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            );
        };
        const DeleteModal = () => {
            return (
                <Modal
                    wrapClassName='ms-order-template-add-to-cart-custom modal-width-parent'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                    toggle={() => {
                        setDeletedToogleShow && setDeletedToogleShow(false);
                    }}
                >
                    <div className='alert-modal-body-container'>
                        <ModalHeader
                            toggle={() => {
                                setDeletedToogleShow && setDeletedToogleShow(false);
                            }}
                        >
                            {deleteProductLabel}
                        </ModalHeader>
                        <ModalBody>
                            <div>
                                <span>{deleteProductFromOrderTemplate}</span>
                            </div>
                            <div className='actions-container'>
                                <span className='_action-btn'>
                                    {deleteButtonText} {removeButton}
                                </span>

                                <button
                                    className='msc-delete-orderTemplateList-btn btn  cancel-btn '
                                    onClick={() => {
                                        setDeletedToogleShow && setDeletedToogleShow(false);
                                    }}
                                >
                                    {backText}
                                </button>
                            </div>
                        </ModalBody>
                    </div>
                </Modal>
            );
        };

        if (!product) {
            return null;
        }

        const {
            key,
            selectLine,
            productImage,
            //productLineCatalog,
            productPrice,
            productNumber,
            removeButton,
            productInfo,
            productUnitOfMeasure,
            productQuantityView,
            productQuantity,
            popUp,
            isMobile,
            extraActionsPopup,
            //isMultipleCatalogFeatureEnabledInHq,
            disabled,
            isDiscontinued,
            isRequestPrice
        } = product;

        const lineVisibility = disabled
            ? {
                  pointerEvents: 'none',
                  opacity: 0.5
              }
            : {
                  pointerEvents: 'auto',
                  opacity: 1
              };

        const disableElement: React.CSSProperties = lineVisibility as React.CSSProperties;

        return (
            <>
                {toogleShow && index === indexValue && <ShowModal />}
                {deletedToogleShow && index === indexValue && <DeleteModal />}
                <Node key={key} className={`${ProductsTableRow!.className}`} {...ProductsTableRow}>
                    <td>{selectLine}</td>
                    {/* {!isMobile && isMultipleCatalogFeatureEnabledInHq && <td style={disableElement}>{productLineCatalog}</td>}
            <td style={disableElement}>{productImage}</td> */}
                    {isMobile ? (
                        <td>
                            <div className='product-name'>{productInfo}</div>
                            <div style={disableElement}>
                                {quantityLabel}: {productQuantity}
                            </div>
                        </td>
                    ) : (
                        <td>{productNumber}</td>
                    )}
                    {!isMobile && <td style={disableElement}>{productInfo}</td>}
                    {!isMobile && <td style={disableElement}>{productPrice}</td>}
                    {!isMobile && <td style={disableElement}>{productUnitOfMeasure}</td>}
                    {!isMobile && <td style={disableElement}>{productQuantityView}</td>}
                    {isMobile && <td style={disableElement}>{popUp}</td>}
                    {!isMobile && (
                        <td style={disableElement} className='template-action-btns'>
                            {isDiscontinued || isRequestPrice ? addToBagButtonDisabled() : addToBagButton(index!)}
                            {removeButtonCustom(index!)}
                        </td>
                    )}
                    {!isMobile && <td style={disableElement}>{extraActionsPopup}</td>}
                </Node>
            </>
        );
    };

    //VSI CUSTOMIZATION END
    return (
        <>
            {isSelectedProdPopUpShow && (
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={isSelectedProdPopUpShow}
                    toggle={() => _handlerToClearSelectedPopUp()}
                >
                    <ModalHeader
                        className='msc-lines-added-to-cart-dialog__dialog__header msc-modal__header'
                        toggle={() => _handlerToClearSelectedPopUp()}
                    >
                        {status === 'FAILEDBYZEROPRICE' ? (
                            <h5 className='msc-modal__title error'>
                                <b>{zeroPriceProductText}</b>
                            </h5>
                        ) : (
                            <>
                                {status === 'SUCCESS' ? (
                                    addedLinesToPassArr.length > 1 ? (
                                        <h5 className='msc-modal__title'>
                                            <b>
                                                {addedLinesToPassArrSuccessfull?.length} {productsText}
                                            </b>
                                            <span> {addedToCartText}</span>
                                        </h5>
                                    ) : (
                                        <h5 className='msc-modal__title'>
                                            <b>
                                                {addedLinesToPassArr.length} {productSingleText}
                                            </b>
                                            <span> {addedToCartText}</span>
                                        </h5>
                                    )
                                ) : (
                                    <h5 className='msc-modal__title error'>
                                        <b>{addedToCartFailureCustomMessage}</b>
                                    </h5>
                                )}
                            </>
                        )}
                    </ModalHeader>
                    <ModalBody className='msc-lines-added-to-cart-dialog__dialog__body msc-modal__body'>
                        {/* <div className='_header-details'>
                            <span className='_name'>Name</span>
                            <span className='_quantity'>Quantity</span>
                        </div> */}
                        {addedLinesToPassArrSuccessfull &&
                            addedLinesToPassArrSuccessfull?.map(e => {
                                return (
                                    e &&
                                    e.product && (
                                        <div className='_details'>
                                            <span className='_prod-name'>{e?.product?.Name!}</span>
                                            {/* <span className='_prod-quantity'>{e?.productListLine?.Quantity!}</span> */}
                                        </div>
                                    )
                                );
                            })}
                        {isAllselectedItemsAddedSuccessfully ? (
                            <span className='all-products-not-added'>{itemsExceedQuantityLimitsAddedToCartText}</span>
                        ) : null}
                    </ModalBody>
                    <ModalFooter className='msc-lines-added-to-cart-dialog__dialog__footer msc-modal__footer'>
                        <a
                            href={
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup &&
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup.linkUrl &&
                                props.config.viewCartAndCheckoutLinkForSelectedItemPopup.linkUrl.destinationUrl
                            }
                            className='msc-lines-added-to-cart-dialog__dialog__view-cart-button msc-btn'
                        >
                            {viewCartAndCheckoutText}
                        </a>
                        <Button
                            onClick={() => _handlerToClearSelectedPopUp()}
                            className='msc-lines-added-to-cart-dialog__dialog__continue-shopping msc-btn'
                        >
                            {closeWindowButtonText}
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            <Module {...OrderTemplateLines}>
                {heading}
                <div className='order-template-heading-custom-div'>
                    {OrderTemplateActions && (
                        <Node {...OrderTemplateActions}>
                            <div className='order-template-buttons-custom-div'>
                                {orderActions?.addTemplateToBag}
                                {orderActions?.renameTemplate}
                                {orderActions?.removeTemplate}
                                {orderActions?.actionsSplitButton}
                                {!isDetailsDisplayed && productsStatusMessage}
                            </div>
                        </Node>
                    )}
                </div>
                {bulkOrderLineActions}
                {status !== 'SUCCESS' && statusMessage}
                {ProductsTable && orderLines && orderLines.length > 0 && (
                    <Node className='ms-order-template__content'>
                        <Node {...ProductsTable}>
                            {ProductsTableHeading}
                            <tbody>
                                {orderLines &&
                                    orderLines.map((product, index) => {
                                        return _renderItem(
                                            product,
                                            productQuantityText,
                                            ProductsTableRow,
                                            toogleShow,
                                            setToogleShow,
                                            deletedToogleShow,
                                            setDeletedToogleShow,
                                            productsStatusMessage,
                                            index
                                        );
                                    })}
                            </tbody>
                        </Node>
                        {pagination}
                    </Node>
                )}
                {/* {itemAddedToCartDialog} */}
                <Modal
                    wrapClassName='ms-order-template-mobile-view-modal'
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={isDetailsDisplayed}
                    toggle={toggleDetails}
                >
                    <ModalHeader toggle={toggleDetails}>{productDetailsText}</ModalHeader>
                    <ModalBody>
                        <ul>
                            {/* <li>{detailedProductView?.productImage}</li> */}
                            <li className='product-info'>
                                <span>{productText}:</span>
                                {detailedProductView?.productInfo}
                            </li>
                            <li>
                                <span>{productLineCatalogName}:</span>
                                {detailedProductView?.productLineCatalog}
                            </li>
                            <li>
                                <span>{productNumberText}:</span>
                                {detailedProductView?.productNumber}
                            </li>
                            <li>
                                <span>{productUnitPriceText}:</span> {detailedProductView?.productPrice}
                            </li>
                            <li>
                                <span>{productUOMText}:</span> {detailedProductView?.productUnitOfMeasure}
                            </li>
                            <li>
                                <span>{productQuantityText}:</span>
                                {detailedProductView?.productQuantityView}
                            </li>
                            {productsStatusMessage && <li>{productsStatusMessage}</li>}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={toggleDetails} className='msc-add-order-template-to-cart btn-update-template msc-btn'>
                            {renameOrderTemplateButtonText}
                        </Button>
                        <Button onClick={toggleDetails}>{cancelBtnLabel}</Button>
                    </ModalFooter>
                </Modal>
            </Module>
        </>
    );
};

export default OrderTemplateLinesView;
